import { render, staticRenderFns } from "./VTick.vue?vue&type=template&id=ea86ddda&"
import script from "./VTick.vue?vue&type=script&lang=js&"
export * from "./VTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports